import PropTypes from 'prop-types';

export default {
  users: PropTypes.array
};
